import Button from './Button';
import Text from './Text';
import { t } from '../i18n/langue';

/**
 * L'échec de chargement, dit comme tel — audit UI/UX du 2026-09-23.
 *
 * Aucun écran ne lisait `isError` : une panne s'affichait « Aucune conversation »
 * ou des indicateurs à 0. C'est le « zéro plausible et faux » que #27 a refusé.
 */
interface EtatErreurProps {
    onReessayer: () => void;
    texte?: string;
}

export default function EtatErreur({ onReessayer, texte = t('composants.erreurChargement') }: EtatErreurProps) {
    return (
        <div role="alert" className="flex flex-col items-center gap-3 p-6 text-center">
            <Text variante="petit" ton="danger">
                {texte}
            </Text>
            <Button libelle={t('commun.reessayer')} variante="secondaire" onPress={onReessayer} />
        </div>
    );
}
